import { render } from "./AdviceSection.vue?vue&type=template&id=a921f112&scoped=true"
import script from "./AdviceSection.vue?vue&type=script&lang=js"
export * from "./AdviceSection.vue?vue&type=script&lang=js"

import "./AdviceSection.vue?vue&type=style&index=0&id=a921f112&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a921f112"]])

export default __exports__